/**
 * Connection State Store
 * Manages XMPP backend connection state using Zustand
 */
import { create } from 'zustand';
// ============================================================================
// Initial State
// ============================================================================
const initialConnectionInfo = {
    state: 'disconnected',
};
// ============================================================================
// Store
// ============================================================================
export const useConnectionStore = create((set, get) => ({
    // Initial state
    backend: null,
    connectionInfo: initialConnectionInfo,
    // Actions
    setBackend: (backend) => {
        // Register connection state change handler
        backend.setEventHandlers({
            onConnectionStateChange: (info) => {
                get().updateConnectionInfo(info);
            },
        });
        set({ backend });
    },
    connect: (username, password) => {
        const { backend } = get();
        if (!backend) {
            throw new Error('Backend not initialized');
        }
        try {
            backend.connect({ jid: username, password });
        }
        catch (error) {
            console.error('[ConnectionStore] Connect failed:', error);
            throw error;
        }
    },
    disconnect: () => {
        const { backend } = get();
        if (!backend) {
            return;
        }
        try {
            backend.disconnect();
        }
        catch (error) {
            console.error('[ConnectionStore] Disconnect failed:', error);
            throw error;
        }
    },
    updateConnectionInfo: (info) => {
        set({ connectionInfo: info });
    },
}));
// ============================================================================
// Selectors
// ============================================================================
export const selectConnectionState = (state) => state.connectionInfo.state;
export const selectJid = (state) => state.connectionInfo.jid;
export const selectBareJid = (state) => state.connectionInfo.bareJid;
export const selectIsConnected = (state) => state.connectionInfo.state === 'authenticated';
export const selectIsConnecting = (state) => state.connectionInfo.state === 'connecting' || state.connectionInfo.state === 'authenticating';
//# sourceMappingURL=connection.js.map